var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowLeft2 = function SvgArrowLeft2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292893 5.68149C-0.0976317 6.06451 -0.0976317 6.68549 0.292893 7.06851L5.79289 12.4627C6.18342 12.8458 6.81658 12.8458 7.20711 12.4627C7.59763 12.0797 7.59763 11.4587 7.20711 11.0757L2.41421 6.375L7.20711 1.67428C7.59763 1.29126 7.59763 0.670276 7.20711 0.287261C6.81658 -0.095753 6.18342 -0.095753 5.79289 0.287261L0.292893 5.68149Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 6.375C15 5.74935 14.5582 5.25 14.0133 5.25L2.11173 5.25C1.57093 5.25 1.125 5.75368 1.125 6.375C1.125 7.00065 1.56677 7.5 2.11173 7.5L14.0133 7.5C14.5541 7.5 15 6.99632 15 6.375Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-left2.3e3128ce.svg";
export { ForwardRef as ReactComponent };